<template>
  <page-content>
    <panel title="Thông tin tìm kiếm">

      <c-form ref="searchForm" @submit="$refs.table.reload()">

        <b-row>
          <c-input v-model="searchForm.shopOrders"
                   form-group-class="col"
                   label="Shop order"
                   placeholder='Danh sách shop order (Ngăn cách bằng dấu ",")'
                   validate-rules="required"/>
        </b-row>

        <b-row>
          <b-col class="text-center">
            <button class="btn btn-success" type="submit">
              <i class="fas fa-search"></i> Tìm kiếm
            </button>

          </b-col>
        </b-row>
      </c-form>

    </panel>


    <panel title="Kết quả tìm kiếm">
      <c-table ref="table"
               lazy
               :data-filter="dataSearch"
               :header-configs="[
                   {text: '#', width: '50px'},
                   {text: 'Shop order', sortField:'order', sortable: true},
                   {text: 'Mã shop', sortField:'code', sortable: true},
                   {text: 'Tên Shop', sortField:'name', sortable: true},
                   {text: 'Thao tác', width: '150px'},
               ]"
               uri="/cms/api/v1.0/shop/get-all"
      >
        <template #default="{item, index}">
          <td class="text-right">{{ index }}</td>
          <td>{{ item.order }}</td>
          <td>{{ item.code }}</td>
          <td>{{ item.name }}</td>
          <td class="text-center">
            <b-button
                v-if="hasPermission('support_shop_delete_all')"
                class="btn btn-icon"
                title="Reset Shop"
                type="button"
                variant="danger"
                @click="showConfirmResetShop = true; selectedShopOrder = item;"
            >
              <i class="fas fa-trash-undo-alt"></i>
            </b-button>
          </td>
        </template>
      </c-table>
    </panel>

    <jc-dialog ref="dialog" :show.sync="showConfirmResetShop"
               btn-confirm-text='<i class="fas fa-check-circle"></i> Xác nhận'
               :title="`Xác nhận reset shop ${selectedShopOrder.code}`"
               type="red"
               @onConfirm="resetShop(selectedShopOrder.order)"
    >

      <h5 style="font-weight: bold; text-align: justify" class="red">
        Lựa chọn này sẽ xóa hoàn toàn thông tin tất cả sản phẩm và tất cả phiếu nhập/xuất của shop.

        <br>
        <br>
        Thông tin bị xóa sẽ không thể khôi phục lại!
      </h5>
      <h5>
        Xác nhận thực hiện reset shop <code>{{ selectedShopOrder.code }} - {{ selectedShopOrder.name }}</code>?
      </h5>


    </jc-dialog>
  </page-content>
</template>

<script>
export default {
  name: "Index",
  data(){
    return {
      searchForm: {
        shopOrders: ''
      },
      showConfirmResetShop: false,
      selectedShopOrder: {},
    }
  },
  computed:{
    dataSearch(){
      return {
        shopOrders: this.searchForm.shopOrders ? this.searchForm.shopOrders.split(',').map(x => x.trim()) : []
      }
    }
  },
  methods: {
    deleteBill(shopOrder){
      this.$clientService.delete(`/v1.0/warehouse/${shopOrder}`, {
        headers: {
          "shop_order": shopOrder,
          "shop_type": 0
        },
        params: {
          delete_by_shop: true,
        }
      }).then(res => {
        this.$success(`Xóa tất cả phiếu của shop ${shopOrder} thành công!`)
      }).catch(err => {
        this.errorNotify(err);
      })
    },
    deleteProduct(shopOrder){
      this.$packageService.delete(`/v1.0/backdoor/product/0`, {
        headers: {
          shop_order: shopOrder,
          shop_type: 0,
        },
        params: {
          check_image: false
        }
      }).then(res => {
        this.$success(`Xóa tất cả sản phẩm của shop ${shopOrder} thành công!`)
      }).catch(err => {
        this.errorNotify(err);
      })
    },
    resetShop(shopOrder){
      this.deleteBill(shopOrder);
      this.deleteProduct(shopOrder);
      this.showConfirmResetShop = false;
      this.selectedShopOrder = {};
    }

  }
}
</script>

<style scoped>

</style>